import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
import { MatInputModule } from '@angular/material/input'
import {
  MatCell,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatRow,
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table'
import { MatIcon } from '@angular/material/icon'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import { generateHexId } from '../../../../shared/utils/utils'
import { MatButton } from '@angular/material/button'
import { MatDialog } from '@angular/material/dialog'
import { JsonPipe, NgClass } from '@angular/common'
import { ItinerariesItemProposalDuplicateFormComponent } from './itineraries-item-proposal-duplicate-form/itineraries-item-proposal-duplicate-form.component'
import { ResponseRequestModel } from '../../../../core/models/response.model'
import { ItinerariesService } from '../../../../core/services/itineraries/itineraries/itiniraries.service'
import { MatProgressBar } from '@angular/material/progress-bar'

@Component({
  selector: 'itineraries-item-proposal-duplicate',
  imports: [
    MatInputModule,
    MatCell,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatIcon,
    MatPaginator,
    MatRow,
    MatTable,
    MatTableModule,
    MatIcon,
    MatPaginatorModule,
    MatTable,
    MatButton,
    JsonPipe,
    NgClass,
    MatProgressBar,
  ],
  templateUrl: './itineraries-item-proposal-duplicate.component.html',
  styleUrl: './itineraries-item-proposal-duplicate.component.scss',
  providers: [],
  standalone: true,
})
export class ItinerariesItemProposalDuplicateComponent
  implements OnInit, AfterViewInit, OnChanges
{
  constructor(
    private dialog: MatDialog,
    private itinerariesService: ItinerariesService,
  ) {}

  item: any = {}
  itemsList: any[] = []
  loading: boolean = false

  @Output() response: EventEmitter<any> = new EventEmitter()
  @Input() listItineraries: any[] = []
  @Input() tariffSelected: any = {}
  @Input() idProposalItem: any = ''

  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild(MatTable) table: MatTable<any> | undefined

  columns: any[] = [
    {
      keyColumn: 'description',
      key: 'descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'postalCode',
      key: 'cep',
      description: 'Cep',
    },
    {
      keyColumn: 'street',
      key: 'logradouro',
      description: 'Logradouro',
    },
    {
      keyColumn: 'number',
      key: 'numero',
      description: 'Numero',
    },
    {
      keyColumn: 'neighborhood',
      key: 'bairro',
      description: 'Bairro',
    },
    {
      keyColumn: 'city',
      key: 'cidade',
      description: 'Cidade',
    },
    {
      keyColumn: 'areaTarrif',
      key: 'areaTarifario',
      description: 'Área Tarifário',
    },
    {
      keyColumn: 'latitude',
      key: 'latitude',
      description: 'Latitude',
    },
    {
      keyColumn: 'longitude',
      key: 'longitude',
      description: 'Longitude',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]
  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()
  displayedColumns: string[] = [
    'description',
    'postalCode',
    'street',
    'number',
    'neighborhood',
    'city',
    'areaTarrif',
    'action',
  ]

  ngOnInit(): void {
    this.getItineraries()
    this.tableSource = new MatTableDataSource<any>(this.itemsList)
    this.refreshTable()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['listItineraries']) {
      this.treatmentItem()
    }
    if (changes['tariffSelected']) {
      this.treatmentLocation()
    }
  }

  treatmentItem() {
    this.response.emit(this.itemsList)
    this.tableSource = new MatTableDataSource<any>(this.itemsList)
    this.refreshTable()
  }

  treatmentLocation() {
    let list = []
    for (let i = 0; i < this.listItineraries.length; i++) {
      let element = this.listItineraries[i]
      list.push({ ...element, areaTarifario: this.checkCityState(element) })
      console.log('list', list)
    }
    this.itemsList = list
    this.tableSource = new MatTableDataSource<any>(this.itemsList)
    this.refreshTable()

    this.response.emit(this.itemsList)

    // this.itemsList = this.listItineraries
    // this.tableSource = new MatTableDataSource<any>(this.itemsList)
    // this.refreshTable()
  }

  checkCityState(element: any) {
    console.log('this.tariffSelected: ', this.tariffSelected)
    console.log('Element: ', element)
    if (
      (this.tariffSelected.location.stateDestination == element.estado ||
        this.tariffSelected.destination.estado == element.estado ||
        this.tariffSelected.location.stateOrigin == element.estado ||
        this.tariffSelected.origin.estado == element.estado) &&
      (this.tariffSelected.location.cityOrigin == element.cidade ||
        this.tariffSelected.location.cityDestination == element.cidade ||
        this.tariffSelected.destination.cidade == element.cidade ||
        this.tariffSelected.origin.cidade == element.cidade)
    ) {
      return 'S'
    } else {
      return 'N'
    }
  }

  ngAfterViewInit() {
    this.refreshTable()
  }

  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    if (this.table) {
      this.table.renderRows()
    }
  }

  responseForm(element: any) {
    switch (element.action) {
      case 'create':
        this.includeItem(element.item)
        return
      case 'edit':
        this.updateItem(element.item)
        return
      case 'delete':
        this.deleteItemEvent(element.index)
        return
      case 'cancel':
        this.item = {}
        return
    }
  }

  generateId() {
    let id = generateHexId()
    if (this.itemsList.length == 0) {
      return id
    } else {
      let idDistinct = false
      while (!idDistinct) {
        if (
          this.itemsList.findIndex((ele: any) => {
            return ele.idCreate == id
          }) == -1
        ) {
          idDistinct = true
        } else {
          id = generateHexId()
        }
      }
      return id
    }
  }

  includeItem(element: any) {
    this.itemsList.push({ ...element, idCreate: this.generateId() })
    this.tableSource = new MatTableDataSource<any>(this.itemsList)
    this.refreshTable()
    this.response.emit(this.itemsList)
  }

  updateItem(element: any) {
    console.log('ele teste:', element)
    let index = this.itemsList.findIndex((ele: any) => {
      return ele.idCreate == element.idCreate
    })
    this.itemsList.splice(index, 1, (({ index, ...rest }) => rest)(element))
    this.tableSource = new MatTableDataSource<any>(this.itemsList)
    this.refreshTable()
    this.item = {}
    this.response.emit(this.itemsList)
  }

  deleteItemEvent(element: any) {
    let index = this.itemsList.findIndex((ele: any) => {
      return ele.idCreate == element.idCreate
    })
    if (index >= 0) {
      this.itemsList.splice(index, 1)
      this.tableSource = new MatTableDataSource<any>(this.itemsList)
      this.refreshTable()
      this.response.emit(this.itemsList)
    }
  }

  selectItemEvent(element: any) {
    // this.item = element
    const dialogRef = this.dialog.open(
      ItinerariesItemProposalDuplicateFormComponent,
      {
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '100ms',
        maxWidth: '900px',
        // width: '100vw',
        // maxHeight: '100vh',
        // height: '100vh',
        // panelClass: 'dialog-fullscreen',
        data: {
          edit: true,
          item: element,
          location: this.tariffSelected.location,
        },
      },
    )
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.updateItem(response)
      }
    })
  }

  addItineraries() {
    const dialogRef = this.dialog.open(
      ItinerariesItemProposalDuplicateFormComponent,
      {
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '100ms',
        maxWidth: '900px',
        // width: '100vw',
        // maxHeight: '100vh',
        // height: '100vh',
        // panelClass: 'dialog-fullscreen',
        data: { location: this.tariffSelected.location },
      },
    )
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.includeItem(response)
      }
    })
  }

  validTariffSelected() {
    return Object.keys(this.tariffSelected).length > 0
  }

  getItiTreatment(list: any) {
    let newList = []
    if (list.data) {
      for (let index = 0; index < list.data.length; index++) {
        const element = list.data[index]
        let item = {
          areaTarifario: element.areaTarifario,
          bairro: element.bairro,
          cep: element.cep,
          cidade: element.cidade,
          complemento: element.cidade,
          descricao: element.localParada,
          estado: element.estado,
          // idCreate: this.generateId(),
          latitude: element.latitude,
          logradouro: element.logradouro,
          longitude: element.longitude,
          numero: element.numero,
          pais: 'Brasil',
          trecho: element.trecho,
        }
        this.includeItem(item)
      }
    }
    // this.itemsList = newList
    // this.tableSource = new MatTableDataSource<any>(this.itemsList)
    // this.refreshTable()
    // this.response.emit(this.itemsList)
    // this.loading = false
  }

  getItineraries() {
    if (this.idProposalItem && this.idProposalItem != '') {
      // this.loading = true
      this.itinerariesService
        .listPagedItinerariesStopByItemPropose(this.idProposalItem, 1, 1000)
        .subscribe({
          next: (response: any) => {
            this.getItiTreatment(response)
          },
          error: (err: ResponseRequestModel) => {
            console.error(err)
            // this.loading = false
          },
          complete: () => {
            // this.loading = false
          },
        })
    }
  }
}
